export default __webpack_public_path__ + "img/menu.2d406155.svg";